// extracted by mini-css-extract-plugin
module.exports = {"social__container":"Social_social__container__U3rck","sn__icon":"Social_sn__icon__wRJ__"};